/**
 * @generated SignedSource<<58b988c41e7aa001a445fb0758d2a24b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecoupmentProfile_featuredDeal$data = {
  readonly totalAmountRaising: number | null;
  readonly " $fragmentType": "RecoupmentProfile_featuredDeal";
};
export type RecoupmentProfile_featuredDeal$key = {
  readonly " $data"?: RecoupmentProfile_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecoupmentProfile_featuredDeal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecoupmentProfile_featuredDeal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAmountRaising",
      "storageKey": null
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};

(node as any).hash = "6612f6d70c8e9d9651187eb6225c8e97";

export default node;
